<template>
  <div class="container mt-5 mb-6">
    <div class="row">
      <div class="col-12 text-center">
        <h1 class="ms-lg-9 display-2">Contact Us</h1>
      </div>
    </div>
    <div class="row text-center mt-5">
      <div class="col-12 col-md-4 text-center border-md-end">
        <div class="info info-horizontal">
          <div class="mb-2 d-flex justify-content-center">
            <i class="ni ni-pin-3 text-primary icon-font"></i>
          </div>
          <div class="mb-2 d-flex justify-content-center">
            <h2 class="info-title">Location</h2>
          </div>
          <div>
            <h5 class="pe-auto mb-0 d-flex justify-content-center"
              onclick="window.location = 'https://www.google.com/maps?q=Ernakulam,Kerala'">
              Ernakulam, Kerala
            </h5>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4 mt-4 mt-md-0 text-center border-md-end">
        <div class="info info-horizontal">
          <div class="mb-2 d-flex justify-content-center">
            <i class="fas fa-phone text-primary icon-font"></i>
          </div>
          <div class="mb-2 d-flex justify-content-center">
            <h2 class="info-title">Phone</h2>
          </div>
          <div>
            <h5 class="pe-auto mb-0 d-flex justify-content-center" onclick="window.location = 'tel:+91 8921 887 520'">
              +91 8921 887 520
            </h5>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4 mt-4 mt-md-0 text-center">
        <div class="info info-horizontal">
          <div class="mb-2 d-flex justify-content-center">
            <i class="ni ni-single-02 text-primary icon-font"></i>
          </div>
          <div class="mb-2 d-flex justify-content-center">
            <h2 class="info-title">Email</h2>
          </div>
          <div>
            <h5 class="pe-auto mb-0 d-flex justify-content-center"
              onclick="window.location = 'mailto:services@fintrens.com'">
              services@fintrens.com
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
